import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';

interface TippingFeeSummaryProps {
  amountLabel: string;
  coverProcessingFee: boolean;
  onCoverProcessingFeeChange: (checked: boolean) => void;
  processingFeeLabel: string;
  technicianTipLabel: string;
  totalLabel: string;
}

const TippingFeeSummary: React.FC<TippingFeeSummaryProps> = ({
  amountLabel,
  coverProcessingFee,
  onCoverProcessingFeeChange,
  processingFeeLabel,
  technicianTipLabel,
  totalLabel,
}) => (
  <Box
    sx={{
      bgcolor: 'var(--cx-brand-bg)',
      border: '1px solid',
      borderColor: 'var(--cx-brand-border)',
      borderRadius: 1.5,
      overflow: 'hidden',
    }}
  >
    <FormControlLabel
      control={
        <Checkbox
          checked={coverProcessingFee}
          onChange={(event) => onCoverProcessingFeeChange(event.target.checked)}
          sx={{
            color: 'var(--cx-brand-text-muted)',
            '&.Mui-checked': { color: 'var(--cx-brand-primary)' },
          }}
        />
      }
      label={
        <Typography variant="body2" sx={{ color: 'var(--cx-brand-text)', fontWeight: 800 }}>
          Cover payment & payout fees
        </Typography>
      }
      sx={{ m: 0, px: 1.5, py: 0.75, width: '100%' }}
    />

    <Divider sx={{ borderColor: 'var(--cx-brand-border)' }} />

    <Stack spacing={0.75} sx={{ p: 1.5 }}>
      {[
        ['Amount', amountLabel, 800],
        ['Payment & payout fees', processingFeeLabel, 800],
        ['Technician receives', technicianTipLabel, 800],
        ['Total', totalLabel, 900],
      ].map(([label, value, weight]) => (
        <Box key={label} sx={{ display: 'flex', justifyContent: 'space-between', gap: 1 }}>
          <Typography
            variant="caption"
            sx={{
              color: 'var(--cx-brand-text-muted)',
              fontWeight: label === 'Total' ? 800 : undefined,
            }}
          >
            {label}
          </Typography>
          <Typography variant="caption" sx={{ color: 'var(--cx-brand-text)', fontWeight: weight }}>
            {value}
          </Typography>
        </Box>
      ))}
    </Stack>
  </Box>
);

export default TippingFeeSummary;
